export const CLOUDINARY_CONFIG = {
  cloudName: "dwxbd1gg2",
  uploadPreset: "news_upload"
};